import { COLS, ROWS } from './BoardPack.mjs';

// Work on a copy so a rejected paste cannot partially overwrite a draft.
export function writeBoardText(layout, cursor, text) {
    text = text.replace(/\r\n?/g, '\n');
    if (/[^\x20-\x7e\n]/.test(text)) throw new Error('Use printable ASCII characters only (no tabs, Unicode, or control characters).');
    if (layout.length > ROWS || layout.some(row => row.length > COLS || /[^\x20-\x7e]/.test(row))) {
        throw new Error('Fix the map dimensions or invalid characters in a .txt file, then import the corrected board.');
    }
    let result = Array.from({ length: ROWS }, (_, y) => (layout[y] || '').padEnd(COLS, ' '));
    let { x, y, end = false } = cursor;
    let wrapped = false;
    for (const char of text) {
        // A pasted full-width line already advanced to the following row.
        if (char === '\n' && wrapped) { wrapped = false; continue; }
        if (end) throw new Error('Text does not fit on the board. Choose an earlier cell or paste less text.');
        wrapped = false;
        if (char === '\n') {
            if (y === ROWS - 1) throw new Error('There are no more rows. Choose an earlier cell.');
            x = 0; y++;
            continue;
        }
        if (char === 'p') result = result.map(row => row.replace(/p/g, ' '));
        result[y] = result[y].slice(0, x) + char + result[y].slice(x + 1);
        if (x < COLS - 1) x++;
        else if (y < ROWS - 1) { x = 0; y++; wrapped = true; }
        else { end = true; wrapped = true; }
    }
    return { layout: result, cursor: { x, y, end } };
}
